export const getClassTimeConsumed = (classesTimeConsumed) =>
  classesTimeConsumed
    ? classesTimeConsumed.dailyWatchLimit - classesTimeConsumed.todayWatchTime
    : null;

export const getDailyTimeLimit = (classesTimeConsumed) =>
  classesTimeConsumed ? classesTimeConsumed.dailyWatchLimit : null;
